import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a3fed29"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "bg-gray-800 bg-opacity-50 flex w-full fixed h-screen items-center justify-center",
  style: { left: '0px', top: '0px' }
}
const _hoisted_2 = { class: "flex flex-col modal-box w-96" }
const _hoisted_3 = { class: "flex justify-end w-full" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 11L11 1",
    stroke: "#222B45",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 1L11 11",
    stroke: "#222B45",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "flex flex-col gap-4 p-2 w-full" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center w-full" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Add Member")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center text-small" }, " Write Email and assign role to invite a new member in your store. ", -1))
const _hoisted_9 = { class: "flex justify-end" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Add", -1))
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutoComplete = _resolveComponent("AutoComplete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "modal-button-close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
        }, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _hoisted_8,
        _withDirectives(_createElementVNode("input", {
          type: "email",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.Email) = $event)),
          class: "form-field",
          placeholder: "Email"
        }, null, 512), [
          [_vModelText, _ctx.Email]
        ]),
        _createVNode(_component_AutoComplete, {
          modelValue: _ctx.selectedRole,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedRole) = $event)),
          items: _ctx.items,
          "return-by": "'value'",
          "track-by": "value",
          "filter-by": "value",
          "show-by": "value",
          placeholder: "Roles",
          onSubmit: _cache[3] || (_cache[3] = (val) => _ctx.updateRole(val))
        }, null, 8, ["modelValue", "items"]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", {
            class: "button",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
          }, _hoisted_11)
        ])
      ])
    ])
  ]))
}